import * as z from "zod";

import { BustleBeeKeySchema } from "./bustleBees";

export const CustomerSchema = z.object({
  uuid: z.string(),
  nickname: z.string(),
  icon: z
    .string()
    .nullish()
    .transform((s) => {
      const bustleBeeKey = BustleBeeKeySchema.safeParse(s);
      if (bustleBeeKey.success) {
        return bustleBeeKey.data;
      } else {
        return null;
      }
    }),
  createdAt: z.string(),
});
export type Customer = z.infer<typeof CustomerSchema>;
